module.exports = __webpack_public_path__ + "static/media/all-thinks-lokal.8a7b25ed.jpg";